import { TimeWindow } from '@/types';

export const ROMANIAN_TIME_WINDOW_LABELS: Record<TimeWindow, string> = {
  '1day': '1 Zi',
  '1week': '1 Săptămână',
  '1month': '1 Lună',
  '1year': '1 An',
  max: 'Tot timpul',
};

export const getTimeWindowDescription = (
  timeWindow: TimeWindow,
  type: 'price' | 'news'
): string => {
  const baseDesc =
    type === 'price' ? 'Evoluția prețului' : 'Frecvența știrilor';

  let timeDesc = '';

  switch (timeWindow) {
    case '1day':
      timeDesc = 'ultimele 24 de ore';
      break;
    case '1week':
      timeDesc = 'ultimele 7 zile';
      break;
    case '1month':
      timeDesc = 'ultimele 30 de zile';
      break;
    case '1year':
      timeDesc = 'ultimul an';
      break;
    case 'max':
      timeDesc = 'toate datele disponibile';
      break;
  }

  return `${baseDesc} pentru ${timeDesc}`;
};
